import { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";

export const GameVideo = ({ id, g, eager }) => {
  const [open, setOpen] = useState(false);
  const shape = typeof window !== "undefined" && window.matchMedia("(max-width: 639px)").matches ? "vertical" : "wide";
  const src = `/marketing/sportsshields-game-${id}-${shape}`;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="group relative block h-full w-full overflow-hidden text-left" aria-label={`Watch how ${g.name} works`} data-testid={`game-video-open-${id}`}>
        <img src={g.img} alt={`${g.name} board`} className="h-full max-h-80 w-full object-cover md:max-h-none transition-transform duration-500 group-hover:scale-105" loading={eager ? "eager" : "lazy"} />
        <span className="absolute inset-0 flex items-center justify-center bg-slate-900/20 transition-colors group-hover:bg-slate-900/35">
          <span className="flex items-center gap-2 border-2 border-slate-900 bg-lime-300 px-4 py-2 text-sm font-black uppercase text-slate-900 shadow-[4px_4px_0_0_#0f172a] transition-transform group-hover:-translate-y-0.5">
            <Play className="h-4 w-4 fill-current" /> Watch how it works
          </span>
        </span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className={`border-2 border-slate-900 bg-slate-950 p-2 ${shape === "vertical" ? "max-w-[min(92vw,420px)]" : "max-w-4xl"}`} data-testid={`game-video-dialog-${id}`}>
          <DialogTitle className="sr-only">How {g.name} works</DialogTitle>
          {open && <video src={`${src}.mp4`} poster={`${src}.jpg`} controls autoPlay playsInline className="max-h-[85vh] w-full" data-testid={`game-video-${id}`} />}
        </DialogContent>
      </Dialog>
    </>
  );
};
